module.exports = __webpack_public_path__ + "static/WEDDING E&M-391-2f744512535511ce12f522feae7ed39e.jpg";